export function SoundIcon({ active }: { active: boolean }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 14.5V9.5h3.6l4.1-3.6v12.2l-4.1-3.6H4Z" />
      {active ? (
        <>
          <path className="sound-wave wave-one" d="M15 9.1c1.5 1.6 1.5 4.2 0 5.8" />
          <path className="sound-wave wave-two" d="M18 6.4c3 3.1 3 8.1 0 11.2" />
        </>
      ) : <path d="m15.5 9 5 6m0-6-5 6" />}
    </svg>
  )
}

export function ArrowIcon() {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6" /></svg>
}

export function AsteriskIcon() {
  return (
    <svg viewBox="0 0 40 40" aria-hidden="true">
      <path d="M20 3v34M5.3 11.5l29.4 17M5.3 28.5l29.4-17" />
      <circle cx="20" cy="20" r="4" />
    </svg>
  )
}
